// Preview popup prev/next document navigation: ←/→ keys + header ‹ › cluster +
// Home/End/F/T shortcuts. Cycles through DOCUMENT previews in the file list (audio
// rows open the player, so they are skipped). Switches in place via
// updatePreviewContent (which dispatches preview:switched -> header + counter re-sync).

import { getPreviewState, setPreviewState } from '../state.js';
import { updatePreviewContent } from '../content.js';

function getDocPreviewIcons() {
	return Array.prototype.slice.call(
		document.querySelectorAll('#file-list-container .preview-rail .preview-icon.bi-eye[data-action="preview"]'));
}

function decodeRowFile($item) {
	const enc = $item.attr('data-file-data');
	if (!enc) return null;
	try {
		const file = JSON.parse(decodeURIComponent(atob(enc)));
		if (!file.name) file.name = file.n || '';
		if (!file.path) file.path = file.p || '';
		if (file.s !== undefined && !file.size) file.size = file.s * 1000;
		if (file.o !== undefined && file.online === undefined) file.online = file.o;
		if (file.ot !== undefined && file.ot_level === undefined) file.ot_level = file.ot;
		if (file.cat && !file.category) file.category = file.cat;
		return file;
	} catch (e) { return null; }
}

export function setupNavigation(popupElement, newState) {
	const $counter = popupElement.find('.preview-popup__nav-counter');
	const $prev = popupElement.find('.preview-popup__nav-prev');
	const $next = popupElement.find('.preview-popup__nav-next');

	function currentIndex(icons) {
		const st = getPreviewState();
		const cur = st.currentPreviewFile && st.currentPreviewFile.$icon ? st.currentPreviewFile.$icon[0] : null;
		return cur ? icons.indexOf(cur) : -1;
	}
	function refreshCounter() {
		const icons = getDocPreviewIcons();
		const idx = currentIndex(icons);
		if (idx < 0 || !icons.length) {
			$counter.text('');
			$prev.prop('disabled', true);
			$next.prop('disabled', true);
			return;
		}
		$counter.text((idx + 1) + ' / ' + icons.length);
		$prev.prop('disabled', idx <= 0);
		$next.prop('disabled', idx >= icons.length - 1);
	}
	function switchTo(ni, icons) {
		if (ni < 0 || ni >= icons.length) return;
		const $icon = $(icons[ni]);
		const $item = $icon.closest('.file-item');
		const file = decodeRowFile($item);
		const fileKey = $item.data('file-key');
		if (!file || !fileKey) return;
		try { $item[0].scrollIntoView({ block: 'nearest' }); } catch (e) {}
		const st = getPreviewState();
		st.currentPreviewFile = { file, fileKey, $icon };
		setPreviewState(st);
		updatePreviewContent(file, fileKey); // dispatches preview:switched -> header + counter re-sync
		refreshCounter();
	}
	function go(delta) {
		const icons = getDocPreviewIcons();
		const idx = currentIndex(icons);
		if (idx < 0) return;
		switchTo(idx + delta, icons);
	}
	$prev.off('click.previewNav').on('click.previewNav', function(e) { e.preventDefault(); e.stopPropagation(); go(-1); });
	$next.off('click.previewNav').on('click.previewNav', function(e) { e.preventDefault(); e.stopPropagation(); go(1); });

	// Keyboard: ←/→ prev/next document (guarded so it does not fire while typing).
	const keyHandler = function(e) {
		const st = getPreviewState();
		if (!st.previewPopupElement || !st.previewPopupElement.length || !document.body.contains(st.previewPopupElement[0])) return;
		const t = e.target;
		if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
		if (e.key === 'ArrowLeft') { e.preventDefault(); e.stopPropagation(); go(-1); }
		else if (e.key === 'ArrowRight') { e.preventDefault(); e.stopPropagation(); go(1); }
	};
	document.addEventListener('keydown', keyHandler, true);
	newState.navKeyHandler = keyHandler;
	$(document).off('preview:switched.previewNav').on('preview:switched.previewNav', refreshCounter);
	setPreviewState(newState);
	refreshCounter();
}
